export default __webpack_public_path__ + "static/media/safari-browser.dc751281.svg";